module.exports = __webpack_public_path__ + "media/src/images/partners/kit-cbd80a3c0cc6b1e8852b5d6cacbaa1b0.jpg";